<template>
<div>


<template v-if="!is_admin && is_auditor">
<div class="col-12">
<AuditorAuditCalendar></AuditorAuditCalendar>
</div>
</template>



<template v-if="is_admin || is_planner">
<div class="grid">
<div class="col-12 md:col-6">
<CorrectionRequests></CorrectionRequests>
</div>

<div class="col-12 md:col-6">
<OpenNonconformityRequests></OpenNonconformityRequests>
</div>

<div class="col-12">
<AuditCalendar></AuditCalendar>
</div>


</div>

</template>


<template v-if="is_supplier">


<template v-if="supplier_notifications.length">
<div class="grid ">
<div class="col-12">

</div>
<div class="col-12">
<div class=" raised_item animate_class px-4 py-3 mb-6 flow_wrap_active ">
<h3 class="text-primary">{{$store.state.languages.lang_phrases.marka_bildirimleri}}</h3><hr>
<SupplierNotificationDashboardWidget v-for="notification in supplier_notifications" :notification="notification"></SupplierNotificationDashboardWidget>
</div>
</div>
</div>

</template>



<template v-if="supplier_scorecards.length">
<div class=" raised_item animate_class px-4 py-3 mb-6 flow_wrap_active ">
<h3 class="text-primary">{{$store.state.languages.lang_phrases.tedarikci_kartlari}}</h3><hr>
<div class="grid my-4" v-for="card in supplier_scorecards">
<div class="col-12">
<p class="text-primary p-link no-underline font-bold" @click="gotoScorecard(card.id)">{{getTheTranslation(card,"translation")}}</p>
<p >{{getTheTranslation(card,"description")}}</p>
</div>

<div class="col-12">
<div class="flex align-items-center justify-content-end ">
<Button :label="$store.state.languages.lang_phrases.goster" icon="pi pi-eye" class=" p-button-primary p-button-outlined  p-button-sm" @click="gotoScorecard(card.id)"></Button>
</div>
</div>

</div>
</div>

</template>



<div class="grid">

<template v-for="project_supplier in project_suppliers">  

<div  class="col-12 md:col-6" v-if="project_supplier.flowsupplier">
<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4 flow_wrap_active">

<template v-if="project_supplier.project.translations.length">
  <h4 class="font-bold text-primary mb-1 cut-text" v-for="projecttranslation in project_supplier.project.translations" v-show="projecttranslation.language_id == $store.state.auth.user.preflang_id">{{projecttranslation.translation}}</h4>
</template>
<template v-else>
  <h4 class="font-bold text-primary mb-1 cut-text">{{project_supplier.project.name}}</h4>
</template>

<div class="col-12 pb-0 pl-0">
<p class="text-primary  text-sm mb-0 mt-0" ><span class="font-semibold">{{$store.state.languages.lang_phrases.marka}}: </span>{{project_supplier.flowsupplier.flow.brand.name}}</p>
</div>

<div class="col-12 pb-0 pl-0">
<p class="text-primary  text-sm mb-1 mt-0" ><span class="font-semibold cut-text">{{$store.state.languages.lang_phrases.tedarikci}}: </span>{{project_supplier.supplier.name}} - {{project_supplier.supplier.suppliercode}}</p>
</div>


<CollapsableFlowCard viewer="supplier"  :flowsupplier="project_supplier.flowsupplier" :activeflow="project_supplier.activeflow"></CollapsableFlowCard>
</div>
</div>
</template>
</div>




<!--
<SupplierDashboardProjectWrap></SupplierDashboardProjectWrap>
-->


</template>

<template v-if="is_brand">
<div class="grid">

<div class="col-12">
<AuditCalendar></AuditCalendar>
</div>
<div class="col-12 mb-0">
<div class="raised_item"><h2 class="text-primary py-3 px-2">{{$store.state.languages.lang_phrases.aktif}} {{$store.state.languages.lang_phrases.projeler}}</h2></div>
</div>

<div class="col-12 md:col-6" v-for="item in projects">


<ProjectCard  :key="item.id" :project_id="item.id" :is_narrow="true"></ProjectCard>

</div>
</div>
</template>


</div>
</template>

<script>
import SupplierDashboardItem from "./SupplierDashboardItem"
export default {

  name: 'Dashboard',

  data () {
    return {
      dashboard_items:[],
      loading:false,
      projects:[],
      project_suppliers:[],
      flowsuppliers:[],
      supplier_notifications:[],
      supplier_scorecards:[],
    }
  },
  components:{SupplierDashboardItem},
  computed:{
    is_supplier()
    {
      if(this.$store.state.auth.user)
      {
        let user = this.$store.state.auth.user
        let supplier = user.userroles.findIndex((item)=>{return item.name=="supplier"})
        if(supplier!==-1)
        {
            return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
    is_admin()
    {
      if(this.$store.state.auth.user)
      {
        let user = this.$store.state.auth.user
        let supplier = user.userroles.findIndex((item)=>{return item.name=="admin"})
        if(supplier!==-1)
        {
            return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
    is_planner()
    {
      if(this.$store.state.auth.user)
      {
        let user = this.$store.state.auth.user
        let supplier = user.userroles.findIndex((item)=>{return item.name=="planner"})
        if(supplier!==-1)
        {
            return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
    is_auditor()
    {
      if(this.$store.state.auth.user)
      {
        let user = this.$store.state.auth.user
        let supplier = user.userroles.findIndex((item)=>{return item.name=="auditor"})
        if(supplier!==-1)
        {
            return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
    is_brand()
    {
      if(this.$store.state.auth.user)
      {
        let user = this.$store.state.auth.user
        let brand = user.userroles.findIndex((item)=>{return item.name=="brand"})
        if(brand!==-1)
        {
            return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
  },
  watch:
  {
    is_supplier(newVal,oldVal)
    {
      if(newVal)
      {
        this.getSupplierOpenAssignments()
      }
    },
    is_brand(newVal,oldVal)
    {
      if(newVal)
      {
        this.getBrandProjects()
      }
    },
  },
  mounted()
  {
    
  	if(this.is_supplier)
    {
      this.getSupplierOpenAssignments()
      this.getSupplierDashboardNotifications()
      this.getSupplierDashboardScorecards()
    }
    if(this.is_brand)
    {
      this.getBrandProjects()
    }
    
  },
  sockets: {
    emittest (data) {
        console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  methods:{
    async gotoScorecard(card_id)
    {
      let card_data = await this.generalApiGetWithoutLoader("get_supplier_brand_scorecard_route/"+card_id)
      console.log(card_data)
      await this.$router.push({ name: 'Suppliercard', params: { supplier_uuid:card_data.uuid,card_id:card_id } })
    },
    async getSupplierDashboardNotifications()
    {
      this.supplier_notifications = await this.generalApiGetWithoutLoader("get_supplier_dashboard_notifications")
      await console.log("getSupplierDashboardNotifications")
      await console.log(this.supplier_notifications)
    },

    async getSupplierDashboardScorecards()
    {
      this.supplier_scorecards = await this.generalApiGetWithoutLoader("get_all_supplier_brand_scorecards")
      await console.log("getSupplierDashboardScorecards")
      await console.log(this.supplier_scorecards)
    },
    orderProjects(a, b )
    {
       if ( a.project.queue < b.project.queue ){
        return -1;
      }
      if ( a.project.queue > b.project.queue ){
        return 1;
      }
      return 0;

    },
    
    async getBrandProjects()
    {
      console.log("getBrandProjects")
      this.loading = await true
      let data = await this.generalApiGetWithoutLoader("user/get_user_brands")
      await console.log(data)
      let brand_projects = []
      for(let item of data)
      {
        let projects = await this.generalApiGetWithoutLoader("brand_projects/"+item.brand_id)
        brand_projects = await brand_projects.concat(projects)
      }
      this.projects = await brand_projects
      this.loading = await false

    },
    async getSupplierOpenAssignments()
    {
      this.loading = await true
      let data = await this.generalApiGetWithoutLoader("supplier_open_assignments")
      console.log("supplier_open_assignments")
      console.log(data)
      let project_suppliers = await data.project_suppliers
      
      for(let project_supplier of project_suppliers)
      {
        //console.log(project_supplier)
        let flowsupplier = data.flowsuppliers.find((item)=>{
          return item.flow_id == project_supplier.activeflow_id && item.supplier_id == project_supplier.supplier_id
        })
        //console.log("flowsupplier")
        //console.log(flowsupplier)
        if(flowsupplier)
        {
          project_supplier.flowsupplier = flowsupplier
          project_supplier.flowsupplier.project_supplier = project_supplier
        }
        
        
      }

      

      project_suppliers = await project_suppliers.sort(this.orderProjects)

      this.project_suppliers = await project_suppliers
      this.flowsuppliers = data.flowsuppliers
      console.log(this.project_suppliers)
      //items  = await items.sort(this.orderProjects)
      //this.dashboard_items = await items

      this.loading = await false

    },
  	async logout()
  	{

  		 let formdata = new FormData()      
      this.generalSubmission(formdata,"logout",this.afterLogout)
  	},
  	afterLogout(response)
  	{
  		
  		localStorage.removeItem("vrf_token");
  		this.$router.push({ path: '/login' })

  	},
    async clickButton(response)
    {
        // $socket is socket.io-client instance
        //console.log("testi");
        //this.$socket.emit('create_user_channel', { client: this.$store.state.auth.user.uuid })
        let data = await this.generalApiGet("sockettest")
        //await console.log(data);
    },
  }
};
</script>

<style lang="css" scoped>
</style>